import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { TooltipContainer, TooltipTitle } from './style';
var Tooltip = function (_a) {
    var childRef = _a.childRef, children = _a.children, content = _a.content;
    var _b = useState(false), showTooltip = _b[0], setShowTooltip = _b[1];
    var compareSize = function () {
        var element = childRef === null || childRef === void 0 ? void 0 : childRef.current;
        if (element) {
            var hasOverflowingChildren = element.offsetHeight < element.scrollHeight ||
                element.offsetWidth < element.scrollWidth;
            setShowTooltip(hasOverflowingChildren);
        }
    };
    useEffect(function () {
        compareSize();
        window.addEventListener('resize', compareSize);
        return function () {
            window.removeEventListener('resize', compareSize);
        };
    }, []);
    return (_jsxs(TooltipContainer, { children: [children, showTooltip && _jsx(TooltipTitle, { children: content })] }));
};
export default Tooltip;
//# sourceMappingURL=Tooltip.js.map